/**
 * Helper: Format image URL
 * -----------------------------------------------------------------------------
 * See scripts/format/media.js for arguments.
 *
 * @returns {String}
 *
 */
import { formatImageUrl } from '~/format/format-image'

export default (src, options) => {
  return formatImageUrl(src, options)
}
